// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.door-locks-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.door-locks-panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  max-width: 94vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 20px 22px 18px;
}
.door-locks-panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .door-locks-panel {
    animation: none;
  }
}

.door-locks-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;
  flex-shrink: 0;
}
.door-locks-header-icon {
  display: none;
}
.door-locks-header-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  flex: 1;
}
.door-locks-header-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 10px;
  font-size: 13px;
  font-size: 18px;
  line-height: 1;
  padding: 4px 9px;
}
.door-locks-header-close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.door-locks-header-close:active:not(:disabled) {
  transform: translateY(1px);
}
.door-locks-header-close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.door-locks-header-close:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.door-locks-header-close:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}

.door-locks-search {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  margin-bottom: 12px;
  flex-shrink: 0;
}
.door-locks-search:focus {
  outline: none;
  border-color: var(--gold-main);
}
.door-locks-search::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}

.door-locks-rows {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-right: 4px;
}
.door-locks-rows::-webkit-scrollbar {
  width: 6px;
}
.door-locks-rows::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.door-locks-empty {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  font-size: 14px;
  text-align: center;
  padding: 20px 0;
}

.door-locks-row {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 12px;
  transition: border-color 0.12s ease;
}
.door-locks-row:hover {
  border-color: var(--gold-dark);
}
.door-locks-row__info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.door-locks-row__summary {
  color: #ebe8e1;
  font-size: 15px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.door-locks-row__meta {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.door-locks-row__actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.door-locks-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
  flex-shrink: 0;
}

.door-locks-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
}
.door-locks-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.door-locks-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.door-locks-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.door-locks-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.door-locks-btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.door-locks-btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.door-locks-btn--ghost {
  padding: 8px 14px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/DoorLocksList/DoorLocksList.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAPA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AASF;;AANA;EDqBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC/JA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAeF;ADCE;EAAI,sBAAA;ACEN;AD2IE;ECpKF;IDoK4C,eAAA;ECvI1C;AACF;;AApBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AAuBF;AApBE;EAAS,aAAA;AAuBX;AArBE;EDwBA,kDA3BW;EA4BX,gBAAA;EACA,eCzBqB;ED0BrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECaH,OAAA;AA4BJ;AAzBE;ED+CA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;EAMA,iBAAA;EACA,eAAA;EC5FE,eAAA;EACA,cAAA;EACA,gBAAA;AA6CJ;ADaE;EAAyB,qCAAA;EAAuC,8BAAA;ACTlE;ADUE;EAA0B,0BAAA;ACP5B;ADQE;EAAa,YAAA;EAAc,mBAAA;ACJ7B;ADKE;EAAkB,oCAAA;EAAsC,mBAAA;ACD1D;ADyBE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACpBhF;;AA7DA;ED0FE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EChGA,mBAAA;EACA,cAAA;AAwEF;ADyBE;EAAU,aAAA;EAAe,8BAAA;ACrB3B;ADsBE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACf1G;;AAhFA;EDgHE,gBAAA;EACA,qBAAA;EACA,qDAAA;EChHA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAqFF;AD0BE;EAAuB,UAAA;ACvBzB;ADwBE;EAA6B,oCAAA;EAAsC,kBAAA;ACpBrE;;AAzFA;EDUE,eAAA;EACA,gBAAA;EACA,cAlDO;ECwCP,eAAA;EACA,kBAAA;EACA,eAAA;AA8FF;;AA3FA;EDlBE,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;EC4CP,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,mCAAA;AAgGF;AA9FE;EAAU,8BAAA;AAiGZ;AA/FE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAiGJ;AA9FE;EACE,cDlEG;ECmEH,eAAA;EACA,gBAAA;EACA,uBAAA;AAgGJ;AA7FE;EDtBA,eAAA;EACA,gBAAA;EACA,cAlDO;ACwKT;AA9FE;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAgGJ;;AA5FA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AA+FF;;AA5FA;ED3BE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;AC2FF;AD3HE;EAAyB,qCAAA;EAAuC,8BAAA;AC+HlE;AD9HE;EAA0B,0BAAA;ACiI5B;ADhIE;EAAa,YAAA;EAAc,mBAAA;ACoI7B;ADnIE;EAAkB,oCAAA;EAAsC,mBAAA;ACuI1D;AA5HE;EDCA,cA5FO;EA6FP,uBAAA;EACA,uCAAA;AC8HF;AD5HE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACgOT;AAhIE;EACE,iBAAA;EACA,eAAA;AAkIJ","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n.door-locks-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.door-locks-panel {\n  @include ink.panel;\n  @include ink.enter;\n  max-width: 94vw;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 22px 18px;\n}\n\n.door-locks-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 14px;\n  flex-shrink: 0;\n\n  // Decorative glyph, no longer displayed.\n  &-icon { display: none; }\n\n  &-title {\n    @include ink.title(22px);\n    flex: 1;\n  }\n\n  &-close {\n    @include ink.button;\n    @include ink.button-quiet;\n    @include ink.button-sm;\n    font-size: 18px;\n    line-height: 1;\n    padding: 4px 9px;\n  }\n}\n\n.door-locks-search {\n  @include ink.field;\n  margin-bottom: 12px;\n  flex-shrink: 0;\n}\n\n.door-locks-rows {\n  @include ink.scroll;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-right: 4px;\n}\n\n.door-locks-empty {\n  @include ink.hint;\n  font-size: 14px;\n  text-align: center;\n  padding: 20px 0;\n}\n\n.door-locks-row {\n  @include ink.block;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 10px 12px;\n  transition: border-color 0.12s ease;\n\n  &:hover { border-color: var(--gold-dark); }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  &__summary {\n    color: ink.$text;\n    font-size: 15px;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n  }\n\n  &__meta {\n    @include ink.hint;\n  }\n\n  &__actions {\n    display: flex;\n    gap: 6px;\n    flex-shrink: 0;\n  }\n}\n\n.door-locks-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 14px;\n  flex-shrink: 0;\n}\n\n.door-locks-btn {\n  @include ink.button;\n  @include ink.button-sm;\n\n  &--danger {\n    @include ink.button-danger;\n  }\n\n  // Closing the list is the single dismissing action of this view.\n  &--ghost {\n    padding: 8px 14px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
